module.exports = __webpack_public_path__ + "static/media/css3Icon.7ca664e1.svg";